module.exports = __webpack_public_path__ + "img/logo_wasana.ae02a7b6.jpg";